import { action } from 'typesafe-actions'
import { LearningCoursesTypes, LearningCourses } from './types'

export const getLearningCoursesOnce = () => action(LearningCoursesTypes.GET_LEARNING_COURSES_ONCE)

export const fetchCourses = {
  request: () => action(LearningCoursesTypes.FETCH_COURSES_REQUEST),

  success: (payload: { data: LearningCourses[] }) =>
    action(LearningCoursesTypes.FETCH_COURSES_SUCCESS, payload),

  failure: (error: any) => action(LearningCoursesTypes.FETCH_COURSES_FAILURE, error),
}
